'use client'

import {ReactNode} from 'react'
import {useInteractionDetected} from './interaction-provider-client'

type Props = {
  placeholderWidth: number
  placeholderHeight: number
  className?: string
  Adtag?: ReactNode
}

const InteractionPlaceholder = ({placeholderWidth, placeholderHeight, className, Adtag}: Props) => {
  const hasInteracted = useInteractionDetected()
  if (hasInteracted) return null

  return (
    <div style={{height: placeholderHeight, width: placeholderWidth}} className={className}>
      {Adtag}
    </div>
  )
}

export default InteractionPlaceholder
